<template>
  <el-card class="card linkInfoSection">
    <div slot="header">
      <strong class="linkInfoSection__title">关联解锁</strong>
    </div>

    <dl class="linkInfoUnlock">
      <div class="linkInfoUnlock__item">
        <dt class="linkInfoUnlock__label">默认解锁组</dt>
        <dd
          class="linkInfoUnlock__value"
          :class="{ 'linkInfoUnlock__value--muted': !defaultLockName }"
        >
          {{ defaultLockName || '未配置' }}
        </dd>
      </div>

      <div class="linkInfoUnlock__item linkInfoUnlock__item--block">
        <dt class="linkInfoUnlock__label">
          数据集解锁方式
          <span v-if="overrideRows.length" class="linkInfoUnlock__count">{{
            overrideRows.length
          }}</span>
        </dt>
        <dd class="linkInfoUnlock__value">
          <div v-if="overrideRows.length" class="linkInfoUnlock__table">
            <div class="linkInfoUnlock__tableHead">
              <span>解锁组</span>
              <span>数据集</span>
            </div>
            <div
              v-for="(row, index) in overrideRows"
              :key="'lock-override-' + index"
              class="linkInfoUnlock__tableRow"
            >
              <span class="linkInfoUnlock__chip linkInfoUnlock__chip--group">{{
                row.lockGroup
              }}</span>
              <span class="linkInfoUnlock__chip linkInfoUnlock__chip--set">{{
                row.dataSet
              }}</span>
            </div>
          </div>
          <span v-else class="linkInfoUnlock__value--muted">还没有数据集覆盖</span>
        </dd>
      </div>
    </dl>
  </el-card>
</template>

<script>
import { buildLockOverrideRows } from './genericResourceInfoHelper'

/**
 * 通用资源查看页 — 关联解锁只读区。
 * 与编辑页 unlockCard 字段对齐：defaultLockGroupName + wallpaperLockGroupVOList。
 */
export default {
  name: 'GenericResourceUnlockReadonly',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  computed: {
    defaultLockName() {
      const name = this.info && this.info.defaultLockGroupName
      return name ? String(name).trim() : ''
    },
    overrideRows() {
      return buildLockOverrideRows(this.info && this.info.wallpaperLockGroupVOList)
    },
  },
}
</script>

<style scoped>
@import './linkTypography.css';

.linkInfoSection {
  margin-bottom: 16px;
}

.linkInfoSection__title {
  font-size: var(--link-text-lg);
  font-weight: var(--link-font-semibold);
}

.linkInfoUnlock {
  margin: 0;
  display: grid;
  gap: 14px;
}

.linkInfoUnlock__item {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.linkInfoUnlock__item--block {
  align-items: start;
}

.linkInfoUnlock__label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding-top: 2px;
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
}

.linkInfoUnlock__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: var(--link-text-xs);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
  background: var(--link-surface-muted, #f0ebe3);
}

.linkInfoUnlock__value {
  margin: 0;
  font-size: var(--link-text-md);
  color: var(--link-ink);
  word-break: break-word;
}

.linkInfoUnlock__value--muted {
  color: var(--link-ink-muted);
}

.linkInfoUnlock__table {
  width: 100%;
  max-width: 560px;
  border: 1px solid var(--link-line, #eee9e2);
  border-radius: 8px;
  overflow: hidden;
}

.linkInfoUnlock__tableHead,
.linkInfoUnlock__tableRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 10px 12px;
}

.linkInfoUnlock__tableHead {
  font-size: var(--link-text-xs);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
  background: var(--link-canvas, #f5f2ec);
}

.linkInfoUnlock__tableRow {
  align-items: center;
  font-size: var(--link-text-sm);
  border-top: 1px solid var(--link-line, #eee9e2);
}

.linkInfoUnlock__chip {
  min-width: 0;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: var(--link-text-xs);
  line-height: 1.5;
  word-break: break-word;
}

.linkInfoUnlock__chip--group {
  color: var(--link-ink-secondary);
  background: var(--link-workspace, #f3f0ea);
}

.linkInfoUnlock__chip--set {
  color: var(--link-ink-emphasis);
  background: var(--link-surface, #fff);
  border: 1px solid var(--link-line, #eee9e2);
}

@media (max-width: 640px) {
  .linkInfoUnlock__item {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .linkInfoUnlock__tableHead,
  .linkInfoUnlock__tableRow {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
</style>
